<template>
    <div id="app">
        <v-slide-x-transition>
            <v-card v-if="showHelpSection" flat id="main-container">

                <div style="width: 100%; height: 10%; font-size: 5vh; font-weight: bold; color: #4c4c4c">

                    <div style="width: 10%;height: 100%; float: left; display: flex; justify-content: center; align-items: center">
                        <v-btn @click="goBack" icon>
                            <v-icon>
                                fas fa-arrow-circle-left
                            </v-icon>
                        </v-btn>
                    </div>

                    <div style="width: 90%;height: 100%; float: left; padding-right: 10%; display: flex; justify-content: center; align-items: center">
                        Order Status
                    </div>

                </div>
                <div style="width: 100%; height: 90%; padding-top: 2.5%; padding-left: 2.5%; padding-right: 2.5%">

                    <v-card flat style="width: 25%; height: 100%; float: left;">

                        <div style="height: 25%; width: 100%; display: flex; justify-content: center; align-items: center">
                            <v-icon color="green" style="font-size: 15vh;">
                                fas fa-check-circle
                            </v-icon>
                        </div>

                        <div style="height: 10%; width: 100%; display: flex; justify-content: center; align-items: center; font-size: 5vh; font-weight: bold; color: #4c4c4c">
                            Processed
                        </div>

                        <div style="height: 75%; width: 100%; text-align: left">
                            <div style="width: 100%; height: 10%; font-size: 3vh">
                                Description
                            </div>
                            <div style="width: 100%; height: 20%; color: rgba(0,0,0,0.6); font-size: 2vh">
                                Order with this icon represents a payments which has been processed on the console.

                            </div>
                            <div style="width: 100%; height: 10%; font-size: 3vh">
                                How to use?
                            </div>
                            <div style="width: 100%; height: 50%; color: rgba(0,0,0,0.6); font-size: 2vh">
                                Payments with this icon should be processed in a manner instructed by your supervisor.
                                The order status can be changed to "Processed" by clicking on the "Unprocessed" order icon. Once this has been done it cannot be undone.
                            </div>



                        </div>


                    </v-card>

                    <v-card flat style="width: 25%; height: 100%; float: left;">

                        <div style="height: 25%; width: 100%; display: flex; justify-content: center; align-items: center">
                            <v-icon color="red" style="font-size: 15vh;">
                                fas fa-times-circle
                            </v-icon>
                        </div>
                        <div style="height: 10%; width: 100%; display: flex; justify-content: center; align-items: center; font-size: 5vh; font-weight: bold; color: #4c4c4c">
                            Unprocessed
                        </div>

                        <div style="height: 75%; width: 100%; text-align: left; padding-left: 5%; padding-right: 5%">

                            <div style="width: 100%; height: 10%; font-size: 3vh">
                                Description
                            </div>
                            <div style="width: 100%; height: 30%; color: rgba(0,0,0,0.6); font-size: 2vh">
                                Order with this icon represents a payment which not yet have been processed on the console.
                                All new payments entering system will appear "Unprocessed".
                            </div>
                            <div style="width: 100%; height: 10%; font-size: 3vh">
                                How to use?
                            </div>
                            <div style="width: 100%; height: 50%; color: rgba(0,0,0,0.6); font-size: 2vh">
                                Payments with this icon should be processed in a manner instructed by your supervisor.
                                The order can't be changed to "Unprocessed".
                            </div>



                        </div>

                    </v-card>


                    <v-card flat style="width: 25%; height: 100%; float: left;">

                        <div style="height: 25%; width: 100%; display: flex; justify-content: center; align-items: center">
                            <v-icon color="blue" style="font-size: 15vh;">
                                fas fa-backspace
                            </v-icon>
                        </div>
                        <div style="height: 10%; width: 100%; display: flex; justify-content: center; align-items: center; font-size: 5vh; font-weight: bold; color: #4c4c4c">
                            Refunded
                        </div>


                        <div style="height: 75%; width: 100%; text-align: left">

                            <div style="width: 100%; height: 10%; font-size: 3vh">
                                Description
                            </div>
                            <div style="width: 100%; height: 25%; color: rgba(0,0,0,0.6); font-size: 2vh;  padding-right: 2%;">
                                Order with this icon represents a payment which has been refunded.
                                The payment refunds happens outside the application.
                            </div>
                            <div style="width: 100%; height: 10%; font-size: 3vh">
                                How to use?
                            </div>
                            <div style="width: 100%; height: 55%; color: rgba(0,0,0,0.6); font-size: 2vh; padding-right: 2%;">
                                The payment status can be changed to "Refunded" only by supervisors within payment details section.
                            </div>
                        </div>

                    </v-card>


                    <v-card flat style="width: 25%; height: 100%; float: left;">

                        <div style="height: 25%; width: 100%; display: flex; justify-content: center; align-items: center">

                            <v-icon color="orange" style="font-size: 15vh;">
                                fas fa-exclamation-triangle
                            </v-icon>


                        </div>
                        <div style="height: 10%; width: 100%; display: flex; justify-content: center; align-items: center; font-size: 5vh; font-weight: bold; color: #4c4c4c">
                            Highlighted
                        </div>

                        <div style="height: 75%; width: 100%; text-align: left">
                            <div style="width: 100%; height: 10%; font-size: 3vh">
                                Description
                            </div>
                            <div style="width: 100%; height: 20%; color: rgba(0,0,0,0.6); font-size: 2vh">
                                Order with this icon represents a payment which has been highlighted or alerted.
                            </div>
                            <div style="width: 100%; height: 10%; font-size: 3vh">
                                How to use?
                            </div>
                            <div style="width: 100%; height: 60%; color: rgba(0,0,0,0.6); font-size: 2vh">
                                To highlight a payment you have to click and hold on a "Processed" payment.
                                <br>A order only should be highlighted if are unable to find the payees number on the console or have any other issue with processing the order.
                            </div>
                        </div>

                    </v-card>





                </div>

            </v-card>
        </v-slide-x-transition>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Vuetify from 'vuetify'
    import 'vuetify/dist/vuetify.min.css'
    import VueApexCharts from 'vue-apexcharts'

    Vue.use(Vuetify)
    Vue.use(VueApexCharts)
    export default {

        components: {
            apexcharts: VueApexCharts
        },

        data () {
            return {

                showHelpSection: false,

            }
        },
        watch: {

        },
        created: function () {
            document.title = 'Chattube - Help'
            setTimeout(() => this.showHelpSection = true, 500)
        },
        computed: {

        },
        methods: {
            goBack(){

                this.$emit('pageCloseTrigger',true)

            }

        }
    }
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
        padding: 1%;
    }
    .main-selection-div {
        width: 33.3%; height: 100%; float: left;
        display: flex; justify-content: center; align-items: center;
    }
    .selection-icon {
        width: 100%; height: 60%; display: flex; justify-content: center; align-items: center
    }
    .selection-text {
        color: white;width: 100%; height: 40%; display: flex; justify-content: center; align-items: center; font-size: 5vh; font-weight: bold
    }
    .card-area {
        height: 80%;
        width: 90%;
    }
    #main-container {
        width: 100%; height: 100%;

    }
</style>